module.exports = __webpack_public_path__ + "static/bgimage-cadca0a51f233e3650feb38f49a2dbb4.jpg";